import type { SupportedSecondaryDimensions } from '../../components/DataProvider/TopNDataProvider';
import { FilterId, type PrimaryFilterId } from '../types/filters';

export const getSecondaryPrimaryDimension = (
  secondaryDimension: SupportedSecondaryDimensions
): PrimaryFilterId => {
  switch (secondaryDimension) {
    case 'company':
      return FilterId.COMPANY;
    case 'geography':
      return FilterId.GEOGRAPHY;
    case 'role':
      return FilterId.ROLE;
  }
};
